import * as z from "zod/v4";

export const submitShopifyDisputeEvidence = {
  name: "submitShopifyDisputeEvidence" as const,
  input: z.object({ disputeId: z.string() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
